import { GiftSentErrorBody } from './error';
import { GiftSentSuccessBody } from './success';

export { GiftSentErrorBody, GiftSentSuccessBody };
